export default {
  errormsg: {
    http_status: {
      422: '无法响应该请求。请检查请求的参数/方法是否正确',
      500: '服务错误，请重新尝试或者联系技术人员'
    },
    msg: {
      no_permission: '没有访问接口 {0} 的权限'
    }
  }
}
